import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { LogOut, ChevronRight, LayoutDashboard, List } from 'lucide-react';

const MAJADAHONDA_LOGO = 'https://customer-assets.emergentagent.com/job_majadahonda-gis/artifacts/i574mq3v_image.png';

export function Header({ adminMode = false }) {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem('admin_token');
    localStorage.removeItem('admin_name');
    navigate('/admin/login');
  };

  return (
    <header className="sticky top-0 z-50 bg-white/95 backdrop-blur-sm border-b border-slate-200 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="flex items-center justify-between h-16 sm:h-20">
          {/* Left: Majadahonda Coat of Arms + title */}
          <Link to={adminMode ? '/admin' : '/'} className="flex items-center gap-3 group">
            <img
              src={MAJADAHONDA_LOGO}
              alt="Ayuntamiento de Majadahonda"
              data-testid="header-majadahonda-logo"
              className="h-12 sm:h-14 w-auto object-contain transition-transform duration-200 group-hover:scale-105"
              onError={(e) => { e.target.style.display = 'none'; }}
            />
            <div className="hidden sm:block w-px h-10 bg-slate-200" />
            <div className="hidden sm:block leading-tight">
              <p className="text-sm font-semibold text-[#374B67]">Recogida de Enseres</p>
              <p className="text-xs text-slate-500 mt-0.5">Ayuntamiento de Majadahonda</p>
            </div>
          </Link>

          {/* Center: portal context */}
          <div className="flex-1 flex justify-center" data-testid="header-portal-title">
            <span className="text-sm sm:text-base font-semibold text-[#374B67]">
              {adminMode ? (
                <span className="flex items-center gap-2">
                  <span>Panel Administrativo</span>
                  <span className="hidden sm:inline-flex items-center px-2 py-0.5 rounded-full bg-[#374B67] text-white text-xs font-medium">Admin</span>
                </span>
              ) : (
                <span className="text-slate-500 hidden sm:inline">Portal Ciudadano</span>
              )}
            </span>
          </div>

          {/* Right actions */}
          <div className="flex items-center gap-3">
            {adminMode ? (
              <>
                <nav className="hidden md:flex items-center gap-1">
                  <Link to="/admin" className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-sm text-slate-600 hover:bg-slate-100 transition-colors">
                    <LayoutDashboard size={15} /><span>Dashboard</span>
                  </Link>
                  <Link to="/admin/solicitudes" className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-sm text-slate-600 hover:bg-slate-100 transition-colors">
                    <List size={15} /><span>Solicitudes</span>
                  </Link>
                </nav>
                <button
                  onClick={handleLogout}
                  className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-sm text-slate-600 hover:bg-red-50 hover:text-red-600 transition-colors"
                  data-testid="admin-logout-button"
                >
                  <LogOut size={15} /><span className="hidden sm:inline">Salir</span>
                </button>
              </>
            ) : (
              <>
                <Link
                  to="/consulta"
                  className="hidden sm:flex items-center gap-1 text-sm text-slate-600 hover:text-[#374B67] transition-colors font-medium"
                  data-testid="header-consultar-link"
                >
                  Consultar estado <ChevronRight size={14} />
                </Link>
                <Link
                  to="/admin/login"
                  className="hidden md:flex text-xs text-slate-400 hover:text-slate-600 transition-colors"
                >
                  Acceso Admin
                </Link>
              </>
            )}
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;
